import React from "react";
import {
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Box,
    Button,
    Grid,
    Typography,
    TextField,
    Slider,
} from "@mui/material";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";

const ImageContect = () => {
    const theme = localStorage.getItem("theme");
    const { imageSource, setImageSource, imageStyle, setImageStyle, pptImageModel, setPPTImageModel } = useWorkspace();
    const ImageSourceOptions = [
        { code: "aiGenerated", label: "AI Generated" },
        { code: "unsplash", label: "Unsplash" },
        { code: "pictographic", label: "Pictographic" },
        { code: "none", label: "None" },
        // { code: "giphy", label: "GIFs (Giphy)" },
        // { code: "webAllImages", label: "Web Images (All)" },
        // { code: "webFreeToUse", label: "Web Images (Free to Use)" },
        // { code: "webFreeToUseCommercially", label: "Commercial Free Images" },
        // { code: "placeholder", label: "Placeholders" },
        // { code: "noImages", label: "No Images" }
    ];
    const ImageStyleOptions = [
        { code: "minimalistic", label: "Minimalistic" },
        { code:  "sophisticated professional", label:  "sophisticated professional" },
        { code: "corporate professional", label: "Corporate Professional" },
        { code: "modern professional", label: "modern professional" }
    ];
    const ImageModelOptions = [
        { code: "gamma-default", label: "Gamma Default" },
        { code: "sdxl", label: "Stable Diffusion XL" },
        { code: "gpt-image", label: "GPT Image Model" }
    ];



    return (
        <div>
            <Box>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}
                >
                    Select Image Source
                </Typography>

                <Grid container spacing={1}>
                    {ImageSourceOptions.map((item) => (
                        <Grid item key={item.code}>
                            <Button
                                variant="outlined"
                                onClick={() => setImageSource(item.code)}
                                sx={{
                                    backgroundColor: imageSource === item.code ? "#3a3f69" : "#30355f",
                                    color: "white",
                                    border: "1px solid #565b85",
                                    "&:hover": {
                                        backgroundColor:
                                            imageSource === item.code ? "#3a3f69" : "#40446e",
                                    },
                                    borderColor: imageSource === item.code ? "#cac4d0" : "transparent",
                                    mx: 0.5,
                                }}
                            >
                                {item.label}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <Box mt={3}>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}
                >
                    Select Image Style
                </Typography>

                <Grid container spacing={1}>
                    {ImageStyleOptions.map((item) => (
                        <Grid item key={item.code}>
                            <Button
                                variant="outlined"
                                onClick={() => setImageStyle(item.code)}
                                sx={{
                                    backgroundColor: imageStyle === item.code ? "#3a3f69" : "#30355f",
                                    color: "white",
                                    border: "1px solid #565b85",
                                    "&:hover": {
                                        backgroundColor:
                                            imageStyle === item.code ? "#3a3f69" : "#40446e",
                                    },
                                    mx: 0.5,
                                    borderColor: imageStyle === item.code ? "#cac4d0" : "transparent",
                                }}
                            >
                                {item.label}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {/* <Box mt={3}>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}
                >
                    Select Image Model
                </Typography>

                <Grid container spacing={1}>
                    {ImageModelOptions.map((item) => (
                        <Grid item key={item.code}>
                            <Button
                                variant="outlined"
                                onClick={() => setPPTImageModel(item.code)}
                                sx={{
                                    backgroundColor: pptImageModel === item.code ? "#3a3f69" : "#30355f",
                                    color: "white",
                                    border: "1px solid #565b85",
                                    "&:hover": {
                                        backgroundColor:
                                            pptImageModel === item.code ? "#3a3f69" : "#40446e",
                                    },
                                    mx: 0.5,
                                    borderColor: pptImageModel === item.code ? "#cac4d0" : "transparent",
                                }}
                            >
                                {item.label}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Box> */}


        </div>
    )
}

export default ImageContect